import PureContextMenu from "pure-context-menu";
import {changeLayerMenuGroupItem} from "@/helpers/layer-menu-helper";

export function initContextMenu() {
    const items = [
        {
            label: "Zet alle lagen uit",
            callback: (e) => {
                showHideLayerGroups(e, false)

            },
        },
        {
            label: "Zet alle lagen aan",
            callback: (e) => {
                showHideLayerGroups(e)
            },
        },
    ];

    document.querySelectorAll(".layerMenuGroupToggleHeader").forEach((el) => {
        new PureContextMenu(el, items);
    })
}

export function showHideLayerGroups(event, show = true) {

    // console.log(event)
    const layerMenuGroup = event.target.closest('layer-menu-group')

    const depth = layerMenuGroup.dataset.depth
    const key = layerMenuGroup.dataset.key
    const branch = window.branch[depth][key]
    const parentId = depth + '-' + branch.ID

    layerMenuGroup.querySelectorAll(`layer-menu-group-item`).forEach(element => {
        let elementChecked = element.querySelector('input')
        if(elementChecked.checked !== show) {
            elementChecked.checked = show
            changeLayerMenuGroupItem(event, element)
        }
    })

    layerMenuGroup.querySelectorAll(`layer-menu-group > layer-menu-group-merged`).forEach(element => {
        let elementChecked = element.querySelector('input')
        if(elementChecked.checked !== show) {
            elementChecked.click()
        }
    })
}

export function showHideDomainListItems(element, show = true) {
    element.target.closest('layer-menu-group-item').querySelectorAll('.layer-over-view-domain-list input').forEach(el => {
        if(el.checked) {
            if(!show) {
                el.click()
            }
        } else {
            if(show) {
                el.click()
            }
        }
    })
}

export function initContextMenuDomainList(element) {

    const items = [
        {
            label: "Zet alle categorieën uit",
            callback: (e) => {
                showHideDomainListItems(e, false)
            },
        },
        {
            label: "Zet alle categorieën aan",
            callback: (e) => {
                showHideDomainListItems(e)
            },
        },
    ];

    new PureContextMenu(element.children[0], items);
}
